import { render, staticRenderFns } from "./ArchiveRegister.vue?vue&type=template&id=4220bb93&"
import script from "./ArchiveRegister.vue?vue&type=script&lang=js&"
export * from "./ArchiveRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports